import mqtt from "mqtt/dist/mqtt";
import moment from "moment-timezone";

const state = () => ({
  connection: {
    clean: process.env.VUE_APP_MQTT_CLEAN,
    connectTimeout: process.env.VUE_APP_MQTT_CONNECT_TIMEOUT, // ms
    reconnectPeriod: process.env.VUE_APP_MQTT_RECONNECT_PERIOD, // ms
    username: process.env.VUE_APP_MQTT_USERNAME,
    password: process.env.VUE_APP_MQTT_PASSWORD,
  },
  qos: process.env.VUE_APP_MQTT_QOS,
  subscriptions: [],
  client: { connected: false },
  showing_history_address: "",
  showing_history_values: [],
});

const getters = {
  getHistoryValues(state) {
    return state.showing_history_values;
  },
};

const mutations = {
  addSubscription(state, topic) {
    if (!state.subscriptions.includes(topic)) {
      state.subscriptions.push(topic);
    }
  },

  deleteSubscription(state, topic) {
    state.subscriptions = state.subscriptions.filter((s) => s != topic);
  },

  setShowingHistoryAddress(state, payload) {
    state.showing_history_values = [];
    state.showing_history_address = payload;
  },

  addHistoryValue(state, payload) {
    state.showing_history_values.push(payload);
  },
};

const actions = {
  createConnection({ state, dispatch }, scripciones= []) {
    const protocol = process.env.VUE_APP_LOCAL == "1" || window.location.protocol.includes("https") ? "wss" : "ws";
    const connectUrl = `${protocol}://${
      process.env.VUE_APP_LOCAL == "1" ? process.env.VUE_APP_MQTT_HOST : window.location.hostname
    }:${process.env.VUE_APP_MQTT_PORT}`;

    try {
      state.client = mqtt.connect(connectUrl, state.connection);
    } catch (error) {
      console.log("mqtt.connect error", error);
    }

    state.client.on("connect", () => {
      state.client.connected=true;
      console.log("Connected!!");
      scripciones.forEach(element => {
        dispatch('doSubscribe', element)
      });
    });

    state.client.on("reconnect", () => {
      console.log("Reconnecting...");
    });

    state.client.on("error", (error) => {
      console.error("Connection failed", error);
    });
  },

  doSubscribe({ state, commit, dispatch }, topic) {
    console.log("Intenta suscribirse a ", topic)
    console.log(state.client.connected)
    if (!state.client.connected) {
      dispatch("createConnection");
    }
    if (!state.subscriptions.includes(topic)) {
      state.client.subscribe(topic, this.qos, (error) => {
        if (error) {
          console.log("Subscribe to topic error", error);
          return;
        }
        console.log("Subscribed to topic", topic);
        commit("addSubscription", topic);
      });
    } else {
      console.log("Already subscribed");
    }
  },

  doUnsubscribe({ state, commit }, topic) {
    if (!state.client.connected) {
      console.log("Not connected");
      return;
    }
    state.client.unsubscribe(topic, (error) => {
      if (error) {
        console.log("Unsubscribe error", error);
      } else {
        console.log("Unsubscribed successfully");
        state.client.unsubscribe(topic);
        commit("deleteSubscription", topic);
      }
    });
  },

  doPublish({ state }, payload) {
    if (!state.client.connected) {
      console.log("Not connected");
      return;
    }
    if (payload.topic && payload.message !== null) {
      console.log("Publishing...");
      console.log(payload.topic + ": " + JSON.stringify(payload.message));

      state.client.publish(payload.topic, JSON.stringify(payload.message), this.qos, (error) => {
        if (error) {
          console.log("Publish error", error);
        } else {
          console.log("Succesfully published " + JSON.stringify(payload.message) + " in " + payload.topic);
        }
      });
    }
  },

  destroyConnection({ state }) {
    if (state.client.connected) {
      try {
        state.client.end(false, () => {
          console.log(`Successfully disconnected!`);
        });
      } catch (error) {
        console.log("Disconnection failed", error.toString());
      }
    } else {
      console.log("Already disconnected");
    }
  },

  setShowingHistoryAddress({ commit }, payload) {
    commit("setShowingHistoryAddress", payload);
  },

  addHistoryValue({ commit }, payload) {
    commit("addHistoryValue", {
      formatted_timestamp: moment.tz(moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss"),
      formatted_value: payload.value,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
